import React, { useState, useEffect } from "react";
import "../landingPage/landingPage";
import { useNavigate, useParams } from 'react-router-dom';
import { verifyInvitation, acceptNomineeInvitation, declineNomineeInvitation } from '../../api/api'


export default function InheritancePage() {

    const { inheritanceString } = useParams();
    const navigate = useNavigate();
    const [validToken, setValidToken] = useState(false);
    const [tokenLoader, setTokenLoader] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');


    useEffect(() => {

        verifyInviteToken(inheritanceString);

    }, []);


    const verifyInviteToken = async (inheritanceString) => {
        try {
            const { status, message } = await verifyInvitation(inheritanceString);
            console.log('verifyInviteToken API Response:', status, message);
            if (status) {
                setValidToken(true);
                setTimeout(() => {
                    setTokenLoader(true);
                }, 2000);
            } else {
                setErrorMessage(message || 'Invalid token.');
            }
        } catch (error) {
            console.error('verifyInviteToken Error:', error);
            setErrorMessage(error.message || 'Something went wrong.');
        }
    };


    const handleAcceptSubmit = async () => {
        try {
            const { status, message } = await acceptNomineeInvitation(inheritanceString)
            console.log('handleAcceptSubmit res', status, message)
            if (status) {
                messageShowHandler("Inheritance Invitation accepted successfully");

            }

        } catch (error) {
            console.log('handleAcceptSubmit', error)
        }
    }

    const handleDeclineSubmit = async () => {
        try {
            const { status, message } = await declineNomineeInvitation(inheritanceString)
            console.log('handleDeclineSubmit res', status, message)
            if (status) {
                messageShowHandler("Inheritance Invitation Declined successfully");

            }

        } catch (error) {
            console.log('handleDeclineSubmit', error)
        }
    }


    const messageShowHandler = (msgText) => {
        navigate("/response", { state: msgText });
    }

    return (
        <div className='landingPage'>
            {
                !tokenLoader &&
                <div className="loaderContainer">
                    {validToken ? (
                        <h2>Link Verified Successfully</h2>
                    ) : errorMessage ? (
                        <h2 className="error">{errorMessage}</h2>
                    ) : (
                        <span className="loaderAnimation">Loading...</span>
                    )}
                </div>
            }
            {

                <div className='landingContentPart'>
                    <h3 className='headingtext'>
                        Invite for Inheritance process
                    </h3>
                    <p className='paraText'>
                        If you wish to accept the inheritance, please click the link and select 'Accept'. If you do not wish to become a inheritance, you may choose 'Decline' instead.
                    </p>
                    <div className='btnWrapper'>
                        <button className='primaryBtn' onClick={handleAcceptSubmit}>Accept</button>
                        <button className='cancelBtn' onClick={handleDeclineSubmit}>Decline</button>
                    </div>
                </div>
            }

        </div>
    )
}
